import { withRouter } from 'react-router'


export default function (target:any) {
  return <any>withRouter(target);
}